import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { onSocketEvent } from "../../../realtime/socketClient";
// New notifications arrive live over the app's socket ("legal:notification",
// fired by the backend's notify()); the poll is only the fallback for a missed
// event, so it can be slow.
const POLL_MS = 120000;
export function NotificationBell() {
    const [items, setItems] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);
    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);
    const navigate = useNavigate();
    function load() {
        api
            .get("/notifications")
            .then((r) => {
            setItems(r.items);
            setUnreadCount(r.unreadCount);
        })
            .catch(() => { });
    }
    useEffect(() => {
        load();
        const interval = setInterval(load, POLL_MS);
        const unsubscribe = onSocketEvent("legal:notification", load);
        return () => {
            clearInterval(interval);
            unsubscribe();
        };
    }, []);
    useEffect(() => {
        function onClickOutside(e) {
            if (rootRef.current && !rootRef.current.contains(e.target))
                setOpen(false);
        }
        document.addEventListener("mousedown", onClickOutside);
        return () => document.removeEventListener("mousedown", onClickOutside);
    }, []);
    async function markAllRead() {
        await api.put("/notifications/read-all", {}).catch(() => { });
        load();
    }
    async function openNotification(n) {
        if (!n.isRead) {
            await api.put(`/notifications/${n.id}/read`, {});
            load();
        }
        setOpen(false);
        if (n.caseId)
            navigate(`/legal-cases/cases/${n.caseId}`);
    }
    return (<div ref={rootRef} style={{ position: "relative" }}>
      <div onClick={() => setOpen((v) => !v)} style={{ position: "relative", cursor: "pointer", padding: 6 }}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#aab7be" strokeWidth="2">
          <path d="M6 8a6 6 0 0112 0c0 7 3 9 3 9H3s3-2 3-9"/>
          <path d="M13.73 21a2 2 0 01-3.46 0"/>
        </svg>
        {unreadCount > 0 && (<span className="mono" style={{
                position: "absolute",
                top: 0,
                right: 0,
                background: "var(--accent)",
                color: "#fff",
                fontSize: "0.6rem",
                fontWeight: 700,
                borderRadius: 9,
                padding: "0 5px",
                minWidth: 15,
                textAlign: "center",
            }}>
            {unreadCount}
          </span>)}
      </div>

      {open && (<div style={{
                position: "absolute",
                top: "calc(100% + 8px)",
                right: 0,
                width: 340,
                maxWidth: "calc(100vw - 32px)",
                maxHeight: 420,
                overflowY: "auto",
                background: "var(--surface)",
                border: "1px solid var(--line-soft)",
                borderRadius: 10,
                boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                zIndex: 20,
            }}>
          <div style={{ padding: "10px 14px", borderBottom: "1px solid var(--line-soft)", fontWeight: 700, fontSize: "0.82rem", color: "var(--ink)", display: "flex", justifyContent: "space-between" }}>
            Notifications
            {unreadCount > 0 && (<button onClick={markAllRead} style={{ background: "none", border: "none", color: "var(--accent-ink)", fontWeight: 600, fontSize: "0.74rem", cursor: "pointer" }}>Mark all read</button>)}
          </div>
          {items.length === 0 && (<div style={{ padding: 16, fontSize: "0.82rem", color: "var(--ink-faint)" }}>Nothing yet.</div>)}
          {items.map((n) => (<div key={n.id} onClick={() => openNotification(n)} style={{
                    padding: "10px 14px",
                    borderBottom: "1px solid var(--line-soft)",
                    cursor: "pointer",
                    background: n.isRead ? "transparent" : "var(--accent-soft)",
                }}>
              <div style={{ fontSize: "0.82rem", fontWeight: 600, color: "var(--ink)" }}>{n.title}</div>
              <div style={{ fontSize: "0.78rem", color: "var(--ink-soft)", marginTop: 2 }}>{n.body}</div>
              <div className="mono" style={{ fontSize: "0.68rem", color: "var(--ink-faint)", marginTop: 4 }}>
                {new Date(n.createdAt).toLocaleString()}
              </div>
            </div>))}
        </div>)}
    </div>);
}
